"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataCounter = void 0;
const countup_js_1 = require("countup.js");
const dataCounter = () => {
    const stats = document.querySelectorAll(".data-columns");
    if (stats.length === 0) {
        return;
    }
    const animateCountUp = (el) => {
        let dataTotal = el.getAttribute("data-total");
        // Value without special characters
        const val = dataTotal.replace(/[^0-9.]/g, "");
        // Get all special characters
        let numShown = false;
        const specialChars = dataTotal.split("").map((i) => {
            if (i.match(/[0-9]/)) {
                numShown = true;
                return null;
            }
            return {
                char: i,
                position: !numShown ? "prefix" : "suffix",
            };
        });
        let options = {
            useEasing: true,
            separator: "",
        };
        // Set number of decimal places
        if (val.includes(".")) {
            options["decimalPlaces"] = val.split(".")[1].length;
        }
        // Set special characters
        specialChars.forEach((i) => {
            if (i) {
                if (i.char !== ",") {
                    options[i.position] = i.char;
                }
                else {
                    options["separator"] = ",";
                }
            }
        });
        let currentCount = new countup_js_1.CountUp(el, val, options);
        if (!currentCount.error) {
            currentCount.start();
        }
        else {
            console.error(currentCount.error);
        }
    };
    let observerOptions = {
        rootMargin: "0px",
        threshold: 0.5,
    };
    let observer = new IntersectionObserver(observerCallback, observerOptions);
    function observerCallback(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let countUpEls = entry.target.querySelectorAll("[data-total]");
                countUpEls.forEach(animateCountUp);
            }
        });
    }
    stats.forEach((i) => {
        if (i) {
            observer.observe(i);
        }
    });
};
exports.dataCounter = dataCounter;
